import { useEffect, type RefObject } from 'react';
import { useEscapeKey } from './useEscapeKey';

/** Popover behaviour: while `open`, a press outside `ref` or Escape calls `onClose` (Escape also gets `escaped`). */
export function useDismiss(ref: RefObject<HTMLElement | null>, open: boolean, onClose: (escaped: boolean) => void) {
  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => !ref.current?.contains(e.target as Node) && onClose(false);
    document.addEventListener('pointerdown', onDown);
    return () => document.removeEventListener('pointerdown', onDown);
  }, [open, ref, onClose]);
  useEscapeKey(() => onClose(true), open);
}
